<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Sidepanel from "./sidepanel";
import axios from "axios";
import {
  authFackMethods
} from "@/state/helpers";
// import CKEditor from "@ckeditor/ckeditor5-vue";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { emailData } from "./data-inbox";

/**
 * Email-inbox component
 */
export default {
  page: {
    title: "Emails",
    meta: [{ name: "description" }]
  },
  components: {
    Layout,
    PageHeader,
    Sidepanel
    // ckeditor: CKEditor.component
  },
  props: ['messageModal'],
  data() {
    return {
      emailData: emailData,
      paginatedEmailData: emailData,
      title: "Emails",
      noRecord: false,
      isLoading: false,
      items: [],
      showModal: false,
      // editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      // page number
      currentPage: 1,
      // default page size
      perPage: 30,
      emailIds: [],
      emails: {},
      preservePage: 1,
      pageLimit:30,
      // start and end index
      startIndex: 1,
      endIndex: 15
    };
  },
  computed: {
    rows() {
      return this.emailData.length;
    }
  },
  created() {
    this.startIndex = 0;
    this.endIndex = this.perPage;
    this.paginatedEmailData = this.emailData.slice(
      this.startIndex,
      this.endIndex
    );
  },
  mounted(){
    this.getNotifications();
  },
  methods: {
    onPageChange() {
      this.startIndex = (this.currentPage - 1) * this.perPage;
      this.endIndex = (this.currentPage - 1) * this.perPage + this.perPage;

      this.paginatedEmailData = this.emailData.slice(
        this.startIndex,
        this.endIndex
      );
    },

    getNotifications(page){
      this.isLoading = true;
      this.noRecord = false;
      if (typeof page === 'undefined'){
        page = 1
      }
      this.preservePage = page;
      let filter = '&per_page='+ this.pageLimit
      axios.get('admin/notifications/sender/all?pagination=true&page='+ page + filter).then(res =>{
        this.emails = res.data.response;
        this.isLoading = false;
        if (!this.emails.data.length){
          this.noRecord = true;
          if (page > 1){
            this.getNotifications(page -1);
          }
        }
      }).catch((err) => {
        if (err.response) {
          if (err.response.status == 401) {
            this.logout();
          }
        }
      })
    },
    ...authFackMethods,
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <!-- Right Sidebar -->
      <div class="col-12">
        <Sidepanel/>

        <div class="email-rightbar mb-3">
          <div class="card">
            <ul class="message-list mt-3">
              <li class="hdngs">
                <div class="col-mail col-mail-1">
                  <a class="title fw-bold">To</a>
                </div>
                <div class="col-mail col-mail-2 fw-bold">
                  Subject
                  <div class="date fw-bold">Received</div>
                </div>
              </li>
              <hr class="mt-0 mb-0">

              <div v-if="noRecord">
                <p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
              </div>

              <div  class="text-center mt-2 mb-0" v-if="isLoading">
                <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                ></b-spinner>
              </div>

              <router-link v-else
                  tag="li"
                  v-for="(email,index) in emails.data"
                  :key="index"
                  :class="{ 'unread': email.is_read === 0 }"
                  :to="`/email/reademail/${email.id}`"
              >
                <div class="col-mail col-mail-1">
                  <a class="title">{{email.receiver ? email.receiver[0].username : "N/A"}}</a>
                </div>
                <div class="col-mail col-mail-2">
                  <router-link
                      tag="a"
                      :to="`/email/reademail/${email.id}`"
                      class="subject"
                  >{{email.subject}}</router-link>
                  <div class="date">{{new Date(email.created_at).toISOString().substr(0,10)}}</div>
                </div>
              </router-link>
            </ul>
          </div>

          <div class="row justify-content-md-between align-items-md-center">
            <div class="col-xl-7">Showing {{emails.from}} - {{emails.to}} of {{emails.total}}</div>
            <!-- end col-->
            <div class="col-xl-5">
              <div class="text-md-right float-end mt-2 pagination-rounded">
                <pagination class="mt-4" :data="emails" :limit="10" @pagination-change-page="getNotifications"></pagination>
              </div>
            </div>
            <!-- end col-->
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>
<style scoped>
.message-list li .col-mail-1 .title{
  left: 20px !important;
}
.message-list li .col-mail-2{
  left: 220px !important;
}
.message-list li.hdngs:hover {
  background: #ffffff;
}
</style>
